<template>
  <div class="footer">
    <div v-if="!isMobile">
      <div class="websitegroup">
        <div class="line">
          <div class="groups w1200">
            <div class="groups_left">
              <div class="tel">联系电话：0351-8686340</div>
              <div class="public">地址：太原市杏花岭区府西街69号</div>
              <div class="public">Email：sxjk@shanxifh.com</div>
              <div class="public">传真：0351-8688121</div>
            </div>
            <div class="groups_link">
              <h2>友情链接</h2>
              <h4>LINK</h4>
              <el-select v-model="value" placeholder="友情链接" @change="linkChange">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.title"
                  :value="item.siteUrl"
                >
                </el-option>
              </el-select>
            </div>
            <div class="groups_right">
              <a href="http://sxlsjr.sxeeex.com/" target="_blank"><img src="../../assets/images/jltpt.png" alt="" /></a>
              
              <img src="../../assets/images/xfjb.png" alt="" />
              <img src="../../assets/images/yjfk.png" @click="
                $router.push({
                  path: 'publicpage?from=7&id=2',
                })
              "  alt="" />
              <img src="../../assets/images/rczp.png"  @click="
                $router.push({
                  path: 'publicpage?from=7&id=1',
                })
              " alt="" />
              <a href="http://OA.shanxifh.com/" target="_blank"> <img src="../../assets/images/oa.png"  alt="" /></a>
             
            </div>
          </div>
        </div>
        <div class="copyright">
          <p class="bq">
            <a href="/">山西金融投资控股集团有限公司</a
            >&nbsp;版权所有&nbsp;&nbsp;&nbsp;<a
              rel="nofollow"
              href="http://beian.miit.gov.cn"
              target="_blank"
              >晋ICP备16008938号</a
            >
          </p>
          <div>
            Copyright © 2017 shanxifh.com All Rights Reserved
            <span>您是第{{ visits }}位浏览者</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobile">
      <div class="mobile_footer">
          <div class="mobile_footer_top">
            <div class="phone">
              联系电话：0351-8686340
            </div>
            <div class="groups_right">
              <a href="http://sxlsjr.sxeeex.com/" target="_blank"><img src="../../assets/images/jltpt.png" alt="" /></a>
              
              <img src="../../assets/images/xfjb.png" alt="" />
              <img src="../../assets/images/yjfk.png" @click="
                $router.push({
                  path: 'publicpage?from=7&id=2',
                })
              "  alt="" />
              <img src="../../assets/images/rczp.png"  @click="
                $router.push({
                  path: 'publicpage?from=7&id=1',
                })
              " alt="" />
              <a href="http://OA.shanxifh.com/" target="_blank"> <img src="../../assets/images/oa.png"  alt="" /></a>
             
            </div>
          </div>
          <div class="mobile_footer_bt">
            <div>山西金融投资控股集团有限公司&nbsp; 版权所有   </div>
            <div><a href="https://beian.miit.gov.cn/">晋ICP备16008938号</a> </div>
            <div style="font-size: 12px;">Copyright © 2017 shanxifh.com All Rights Reserved</div>
            <div style="font-size: 12px;">您是第 {{visits}}位浏览者</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SzyName",
  data() {
    return {
      options: [],
      value: "",
      path: "",
      isMobile: false,
      visits:0
    };
  },
  created() {
    setTimeout(() => {
      this.options = JSON.parse(localStorage.getItem("homepageData")).linkList;
      this.visits = JSON.parse(localStorage.getItem("homepageData")).visits;
    }, 300);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  watch: {
    $route: {
      handler: function (route) {
        this.path = route.path;
        console.log(this.path);
      },
      immediate: true,
    },
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    linkChange(value){
      window.open(value);
    }
  },
};
</script>

<style lang="less" scoped>
.footer {
  // margin-top: 15px;
  width: 100%;
  background-color: #eff2f7;

  .websitegroup {
    color: #ffffff;
    background-size: 100% 100%;
    width: 100%;
    box-sizing: border-box;
    .line {
      // border-bottom: 1px solid #5994e9;

      .title {
        height: 74px;
        line-height: 74px;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .line {
      // border-bottom: 1px solid #5994e9;
      background: url("../../assets/images/footer_bg.jpg") center top;

      .groups {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 0;
        .groups_left {
          margin-bottom: 15px;
          padding-right: 55px;
          margin-top: 20px;
          width: 375px;
          .tel {
            font-size: 22px;
            color: #fed3b1;
            font-weight: bold;
            border-bottom: 1px dashed #fed3b0;
            line-height: 40px;
            margin-bottom: 10px;
          }
          .public {
            color: #fed3b1;
            font-size: 13px;
            margin: 5px 0;
          }
        }
        .groups_link {
          margin-top: 20px;
          padding: 0 15px 0 20px;
          width: 388px;
          h2 {
            font-size: 22px;
            color: #fed3b1;
            font-weight: bold;
            margin-bottom: 0px;
          }
          h4 {
            color: #fed3b1;
            font-size: 13px;
            margin: 10px 0;
          }
          :deep(.el-select) {
            width: 288px;
            .el-input {
              .el-input__inner {
                height: 33px;
                background-color: #e8cbb3;
                &::placeholder{
    color: #9E5305;

                }
              }
              .el-input__suffix {
                top: 5px;
              }
            }
          }
        }
        .groups_right {
          margin-top: 20px;
          img {
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
    .partyLine {
      border-bottom: 1px solid #fff;
    }
  }
  .party {
    background: none;
    background-color: #d41100;
  }
  .copyright {
    text-align: center;
    color: #e8cbb3;
    font-size: 14px;
    background-color: #5f0900;
    padding: 10px 0;
    .bq {
      margin-bottom: 10px;
    }
    a {
      color: #e8cbb3 !important;
      &:hover {
        color: #b50000 !important;
      }
    }
  }
  .mobile_footer {
    .mobile_footer_top{
      background: url('../../assets/images/footer_bg.jpg');
      width: 100%;
      height: 265px;
      .phone{
        line-height: 48px;
        color: #FED3B1;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        padding-top: 10px;
        border-bottom: 1px dashed #FED3B0;
      }
      .groups_right{
        img {
            width: 60px;
            cursor: pointer;
            margin: 15px 15px 0 15px;
          }
      }
    }
    .mobile_footer_bt{
      background: #5F0900;
      padding: 10px 0;
      color: #E8CBB3;
      a{
        color: #E8CBB3;
      }
      div{
        line-height: 18px;
        text-align: center;
      }
    }
  }
}
</style>
